import React from 'react';
import type { WidgetProps } from '../registry';

/**
 * Simple Label Widget for section headers and labels
 * Supports both flat format (widget.label, widget.css_style)
 * and hierarchical format (widget.text, widget.style)
 */
export const SimpleLabelWidget: React.FC<WidgetProps> = ({ widget }) => {
  // Get text from either format
  const text = widget.label || widget.text || '';

  // Convert css_style from backend (kebab-case) to React style (camelCase)
  const convertCssStyle = (
    cssStyle: Record<string, any> | undefined
  ): React.CSSProperties => {
    if (!cssStyle) return {};

    const converted: Record<string, any> = {};
    Object.entries(cssStyle).forEach(([key, value]) => {
      // Convert kebab-case to camelCase
      const camelKey = key.replace(/-([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      );
      converted[camelKey] = value;
    });
    return converted as React.CSSProperties;
  };

  const style = convertCssStyle(widget.css_style);

  // Determine element type based on style hint
  const styleHint = widget.style || 'normal';

  if (styleHint === 'heading') {
    return (
      <h2 className="rul-widget-label rul-label-heading" style={style}>
        {text}
      </h2>
    );
  }

  if (styleHint === 'subheading') {
    return (
      <h3 className="rul-widget-label rul-label-subheading" style={style}>
        {text}
      </h3>
    );
  }

  return (
    <div className="rul-widget-label rul-label-section" style={style}>
      {text}
    </div>
  );
};
